module.exports = __webpack_public_path__ + "static/media/webinar-polyu618.f2fcf5a5.png";